import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const ZEFFY_DONATE_URL = "https://www.zeffy.com/en-US/donation-form/donate-to-change-lives-15706";
export const ZEFFY_5K_URL = "https://www.zeffy.com/en-US/ticketing/step-forward-community-walk";

export const IMAGES = {
    splash: "https://images.pexels.com/photos/35595241/pexels-photo-35595241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920",
    referenceMain: "https://customer-assets.emergentagent.com/job_c4a1c8c8-fe09-426c-82a3-3e55b94b875a/artifacts/vx3j82vx_2_20260607_113148_0002.png",
    welcome: "/img/welcome.png",
    hawkins: "/img/hawkins.png",
    founders: "/img/founders.png",
    illustLeft: "/img/illust_left.png",
    illustRight: "/img/illust_right.png",
    charityRun: "https://images.unsplash.com/photo-1602263515015-dd72f8e9f301?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjaGFyaXR5JTIwcnVuJTIwZXZlbnR8ZW58MHx8fHwxNzgwODQ4Njk2fDA&ixlib=rb-4.1.0&q=85",
};
